import { AxiosInstance } from './axios.core';
import { API_URL } from './api.base';
import { CancelToken } from 'axios';
import { ListResponseModel, ListRuquestModel, OrganizationNodepProps, TagProps } from './models'
export const uploadDoc = (_params: any): Promise<any> => {
  const params = new FormData();
  for (var key in _params) {
    params.append(key, _params[key]);
  }
  return AxiosInstance.put(
    `${API_URL}/documnets`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const getDocList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/documnets`, { params });
}


export const getDoc = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/documnets/${id}`);
}

export const deleteDoc = (id: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/documnets/${id}`);
}

export const pushDocument = (id: string,params:any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/documnets/${id}/push`,{ ...params });
};

export const getDocumentGroup = (id: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/documnets/${id}/group`);
};